module.exports = __webpack_public_path__ + "static/media/OneStopPlus.a0818ca5.pdf";